import {
  batchDeleteDetail,
  checkDetail, // 运营侧查询
  commitExcel,
  deleteCheck,
  deleteDistribute,
  disassembleDetail,
  distributeList,
  distributeListForOperate,
  getCommitRes,
  getDistributeBaseInfo,
  getExistUsableProcess, // 查询批量发放支付结果
  getTemplate,
  queryDetail,
  queryDistributePage,
  queryError,
  queryPayment,
  queryPayRes,
  saveDistribute,
  saveSingleDetail,
  submit,
  updateBank,
  zlbApiExpenseBatchDistributeDetailQueryPost,
} from '../services/batchdistributeExpense';

export default {
  namespace: 'batchDistributeExpense',
  state: {},
  effects: {
    *commitExcel({ payload }, { call }) {
      return yield call(commitExcel, payload);
    },
    *distributeList({ payload }, { call }) {
      return yield call(distributeList, payload);
    },
    *distributeListForOperate({ payload }, { call }) {
      return yield call(distributeListForOperate, payload);
    },
    *getCommitRes({ payload }, { call }) {
      return yield call(getCommitRes, payload);
    },
    *getDistributeBaseInfo({ payload }, { call }) {
      return yield call(getDistributeBaseInfo, payload);
    },
    *deleteDistribute({ payload }, { call }) {
      return yield call(deleteDistribute, payload);
    },
    *queryPayment({ payload }, { call }) {
      return yield call(queryPayment, payload);
    },
    *queryDistributePage({ payload }, { call }) {
      return yield call(queryDistributePage, payload);
    },
    *saveDistribute({ payload }, { call }) {
      return yield call(saveDistribute, payload);
    },
    *batchDeleteDetail({ payload }, { call }) {
      return yield call(batchDeleteDetail, payload);
    },
    *queryDetail({ payload }, { call }) {
      return yield call(queryDetail, payload);
    },
    *queryError({ payload }, { call }) {
      return yield call(queryError, payload);
    },
    *submit({ payload }, { call }) {
      return yield call(submit, payload);
    },
    *updateBank({ payload }, { call }) {
      return yield call(updateBank, payload);
    },
    *saveSingleDetail({ payload }, { call }) {
      return yield call(saveSingleDetail, payload);
    },
    *queryPayRes({ payload }, { call }) {
      return yield call(queryPayRes, payload);
    },
    *getTemplate({ payload }, { call }) {
      return yield call(getTemplate, payload);
    },
    *deleteCheck({ payload }, { call }) {
      return yield call(deleteCheck, payload);
    },
    *disassembleDetail({ payload }, { call }) {
      return yield call(disassembleDetail, payload);
    },
    *checkDetail({ payload }, { call }) {
      return yield call(checkDetail, payload);
    },
    *getExistUsableProcess({ payload }, { call }) {
      return yield call(getExistUsableProcess, payload);
    },
    *zlbApiExpenseBatchDistributeDetailQueryPost({ payload }, { call }) {
      return yield call(zlbApiExpenseBatchDistributeDetailQueryPost, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
